import axios from 'axios'
import { ElMessage } from 'element-plus'

/** 本机空串走 Vite 代理；测试/正式为 auth / testauth 绝对地址 */
const apiBase = (import.meta.env.VITE_API_BASE as string | undefined)?.trim() || ''

export const http = axios.create({
  baseURL: apiBase,
  timeout: 20000,
  withCredentials: true,
})

export type ApiError = Error & { data?: unknown; resultCode?: number }

http.interceptors.response.use(
  (res) => {
    const body = res.data
    if (body && typeof body === 'object' && 'success' in body && body.success === false) {
      const msg = body.msg || '请求失败'
      const err: ApiError = Object.assign(new Error(msg), {
        data: body.data,
        resultCode: body.resultCode,
      })
      if (body.resultCode !== 20001) {
        ElMessage.error(msg)
      }
      return Promise.reject(err)
    }
    return res
  },
  (err) => {
    ElMessage.error(err?.message || '网络错误')
    return Promise.reject(err)
  },
)
